import { createReducer, on } from "@ngrx/store"
import { createDemandeLicence, createDemandeLicenceSuccess, createDemandeLicenceFailure, getAllDemandeLicence, getAllDemandeLicenceSuccess, getAllDemandeLicenceFailure, deleteDemandeLicence, deleteDemandeLicenceFailure, deleteDemandeLicenceSuccess } from "../actions/demande-licence.action"

export interface DemandeLicenceState {
  demandeLicenceState: any
}


export const initialState: DemandeLicenceState = {
  demandeLicenceState: {
    content: [],
    totalPages: 0,
    totalElements: 0,
    pageable: {
      pageNumber: 0,
      pageSize: 20
    }
  }
}

export const demandeLicenceReducer = createReducer(
  initialState,
  on(createDemandeLicence, (state) => ({ ...state })),
  on(createDemandeLicenceSuccess, (state, { reponseDAO }) => ({ ...state, reponseDAO })),
  on(createDemandeLicenceFailure, (state, { error }) => ({ ...state, error })),
  on(getAllDemandeLicence, (state) => ({ ...state })),
  on(getAllDemandeLicenceSuccess, (state, { demandeLicences }) => ({ ...state, demandeLicences })),
  on(getAllDemandeLicenceFailure, (state, { error }) => ({ ...state, error })),
  on(deleteDemandeLicence, (state) => ({ ...state })),
  on(deleteDemandeLicenceSuccess, (state) => ({ ...state })),
  on(deleteDemandeLicenceFailure, (state, { error }) => ({ ...state, error }))

)
